interface Props {
  label: string;
  className?: string;
  labelClassName?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

export const OrangeButton = ({
  label,
  className,
  onClick,
  labelClassName,
  ...rest
}: Props) => {
  return (
    <button
      {...rest}
      onClick={onClick}
      className={`bg-orange-600 border border-gray-border px-6 py-2 rounded active:bg-gray-100 transition ease-linear ${className}`}
    >
      <p
        className={`font-satoshi font-medium text-white text-base ${labelClassName}`}
      >
        {label}
      </p>
    </button>
  );
};
